import { api as whiteboardApi } from './auto-generated/whiteboard'
import { api as eventApi } from './auto-generated/event'

whiteboardApi.enhanceEndpoints({
  endpoints: {
    whiteboardStartWhiteboard: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        dispatch(
          eventApi.util.updateQueryData('eventGetEventById', args, (draftEvent) => {
            draftEvent.event_type = 'WHITEBOARD'
          }),
        )
        dispatch(
          eventApi.util.updateQueryData('eventGetCurrentEvent', undefined, (draftEvent) => {
            draftEvent.event_type = 'WHITEBOARD'
          }),
        )
        try {
          await queryFulfilled
        } catch {}
      },
    },
  },
})

export { whiteboardApi }
